import React, { useEffect, useRef } from 'react';
import { noop } from 'js/utils/methods.util';
import { ManagedPopup } from 'js/components/common/Popup';
import { useFullyCombinedOnClose, useOnClose } from 'js/components/common/PopupManager';
import style from './index.scss';

export const LightBox = ({
    id,
    controls,
    refs: { layerRef },
    data: {
        afterRender = noop,
        onLifetimeEnd = noop,
        isHiddenLightBox,
        lifetime,
        beforeClose,
        afterClose
    }
}) => {
    const containerRef = useRef();
    const closeManagedPopup = useOnClose();
    const closeLightBox = useFullyCombinedOnClose(beforeClose, afterClose);

    /**
     * We can't move it inside `useEffect` because:
     *   - layerRef === undefined before component is rendered
     *   - `useEffect` must be invoked only once, based on this we can't pass `layerRef` as dependencies refs
     */
    if (isHiddenLightBox && layerRef.current) {
        // todo find better solution - it seems the problem is with invalid useEffect dependencies
        // and it seems we can and should move it to useEffect
        layerRef.current.style.display = 'none';
    }

    useEffect(() => {
        let timerId;
        const refCurrent = layerRef.current;

        afterRender(containerRef.current);

        window.addEventListener('popstate', closeLightBox); // close LightBox when navigation buttons are clicked

        if (lifetime) {
            timerId = setTimeout(() => {
                onLifetimeEnd();
                closeManagedPopup();
            }, lifetime);
        }

        return () => {
            clearTimeout(timerId);
            window.removeEventListener('popstate', closeLightBox);

            if (refCurrent) {
                refCurrent.style.display = '';
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <ManagedPopup
            id={id}
            controls={controls}
            onOverlayClick={noop}
            className={style.popup}
            onClose={closeLightBox}
            layerClassNames={style}
        >
            <div className={style.lightBox} ref={containerRef} />
        </ManagedPopup>
    );
};

export default LightBox;
